import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';

import AlertMessage from '../../../../../../../../../component/common/AlertMessage';

const ProductFeatureAssociationForm = (props) => {
    const { formData, formValidateError } = props;

    const [ manageAssociation, setManageAssociation ] = useState([]);

    const selectedFeatureOnChange = (productName, featureOptions) => {
        setManageAssociation((prev) => ({
            ...prev,
            [productName]: featureOptions || [],
        }));
    }

    const [ featureList, setFeatureList ] = useState([]);
    

    let associationFormHtml = '';
    if(formData['step3'].product_setup.length > 0){
        associationFormHtml = formData['step3'].product_setup
            .filter(product => !formData['step3'].product_features_association.hasOwnProperty(product.product_name))
            .map((product) => {
            return (
                <tr key={uuidv4()}>
                    <td>{product.product_name}</td>
                    <td>
                        <Select
                            className='react-select-styled react-select-solid react-select-sm' 
                            classNamePrefix='react-select'
                            options={featureList}
                            placeholder='Select an option' 
                            isMulti
                            onChange={(selectedOptions) => {
                                selectedFeatureOnChange(product.product_name, selectedOptions);
                            }}
                            value={manageAssociation[product.product_name] || []}
                        />
                    </td>
                </tr>
            );
        });
    }

    useEffect(() => {
        if (formData['step3'].features_setup.length > 0) {
            const transformedArray = formData['step3'].features_setup.map(item => ({
                label: item.feature_name,
                value: item.feature_name
            }));
            setFeatureList(transformedArray);
        }
        else{
            setFeatureList([]);
        }
    }, [formData['step3'].features_setup]);

    // ----------- association ------------- //
    const associationSave = () => {
        if(manageAssociation.length === 0){
            toast.error('At least one association must be added.');
            return
        }
        const rmBlankArray = Object.fromEntries(
            Object.entries(manageAssociation).filter(([key, value]) => Array.isArray(value) && value.length > 0)
        );
        if(Object.keys(rmBlankArray).length === 0){
            toast.error('At least one association must be added.');
            return
        }
        props.associationSave(rmBlankArray)
        setManageAssociation([]);
    }
    return (
        <>
            {
                Object.keys(formData['step3'].product_features_association).length !==
                formData['step3'].product_setup.length &&
                <>
                    <div className='row'>
                        <div className='col-md-12'>
                            <table className="table table-row-dashed table-row-gray-300">
                                <thead>
                                    <tr className="fw-bolder fs-6 text-gray-800">
                                        <th className='w-200px'>Product</th>
                                        <th>Feature</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {associationFormHtml}
                                </tbody>
                            </table>
                        </div>
                        <div className='col-md-12 text-end'>
                            <div className="btn btn-dark btn-icon btn-sm" onClick={associationSave}>
                                <FontAwesomeIcon icon={faFloppyDisk} className='fs-5' />
                            </div>
                        </div>
                        <div className='col-md-12 mt-5'>
                            {
                                formValidateError?.product_features_association &&
                                <AlertMessage
                                    sub_title = {formValidateError?.product_features_association}
                                    type = 'danger'
                                />
                            }
                        </div>
                    </div>
                    <div className="separator border-gray-300 my-6"></div>
                </>
            }
        </>
    )
}

export default ProductFeatureAssociationForm